export default "__VITE_ASSET__e191d15c__"